import { EDUGATE_API_URL } from '../config/serviceConfig'

export async function submitLabReportFile({
  trainingTaskId,
  studentId,
  file,
  submitMessage = '',
  headers = {},
}) {
  if (!trainingTaskId) throw new Error('作业 ID 缺失，请选择要提交的作业')
  if (!file) throw new Error('请先选择实验报告')
  const formData = new FormData()
  formData.append('trainingTaskId', String(trainingTaskId))
  formData.append('homeworkId', String(trainingTaskId))
  formData.append('submitMessage', submitMessage || '')
  if (studentId) formData.append('studentId', String(studentId))
  formData.append('file', file)
  const response = await fetch(`${EDUGATE_API_URL}/api/lab_report/submit`, {
    method: 'POST',
    headers,
    body: formData,
  })
  const data = await response.json()
  if (data.code !== 0) throw new Error(data.message || '提交失败')
  return data
}
